import * as React from 'react';
import { Navigate, useParams } from 'react-router';

const MainProjectRedirect = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/inquiries`} replace />;
};

export default MainProjectRedirect;
